<template>
  <div>
    <section class="lg:tw-flex items-center">
      <DualSquare
        v-for="cta in ctas"
        :cta="cta"
        class="tw-bg-cover tw-bg-center tw-relative lg:tw-w-1/2 tw-min-h-[425px] flex items-center justify-center"
      ></DualSquare>
    </section>
  </div>
</template>

<script>
import DualSquare from '~/components/DualSquare.vue'
export default {
  components: { DualSquare },

  props: {
    ctas: {
      default: () => {
        return []
      },
      type: Array,
    },
  },
}
</script>
